<template lang="html">
  <div>
    <div class="content">
      <h1>Generované knihy</h1>
      <v-layout class="layout--controls">
        <v-text-field
          class="input--search control"
          placeholder="Vyhledat"
          outlined
          v-model="search"
        ></v-text-field>
        <v-btn
          color="secondary"
          type="submit"
          class="button--top control"
          @click="fetchData"
          >Refresh dat</v-btn
        >
      </v-layout>
      <h2>Filtrace</h2>
      <v-layout class="layout--controls">
        <v-btn
          color="primary"
          type="submit"
          class="button--small button--filter"
          v-bind:class="{ 'button--filter-active': currentStatus == 'all' }"
          @click="filterStatus('all')"
          >Vše</v-btn
        >
        <v-btn
          color="primary"
          type="submit"
          class="button--small button--filter"
          v-bind:class="{ 'button--filter-active': currentStatus == 'ready' }"
          @click="filterStatus('ready')"
          >V pořadí</v-btn
        >
        <v-btn
          color="primary"
          type="submit"
          class="button--small button--filter"
          v-bind:class="{
            'button--filter-active': currentStatus == 'preparing',
          }"
          @click="filterStatus('preparing')"
          >Připravuje se</v-btn
        >
        <v-btn
          color="primary"
          type="submit"
          class="button--small button--filter"
          v-bind:class="{ 'button--filter-active': currentStatus == 'done' }"
          @click="filterStatus('done')"
          >Připraveno</v-btn
        >
        <v-btn
          color="primary"
          type="submit"
          class="button--small button--filter"
          v-bind:class="{ 'button--filter-active': currentStatus == 'failed' }"
          @click="filterStatus('failed')"
          >Chybné</v-btn
        >
        <v-btn
          color="primary"
          type="submit"
          class="button--small button--filter"
          v-bind:class="{ 'button--filter-active': currentStatus == 'missing' }"
          @click="filterStatus('missing')"
          >Neexistuje</v-btn
        >
        <v-btn
          color="primary"
          type="submit"
          class="button--small button--filter"
          v-bind:class="{ 'button--filter-active': currentStatus == 'deleted' }"
          @click="filterStatus('deleted')"
          >Smazáno</v-btn
        >
      </v-layout>
      <v-layout class="table-items">
        <v-data-table
          locale="cs"
          sort-by="created_at"
          sort-desc
          :headers="headers"
          :items="items"
          :loading="false"
          item-key="created_at"
          :items-per-page="perPage"
          :options.sync="options"
          :server-items-length="total"
          :mobile-breakpoint="0"
          class="elevation-1 full-width frankjoy-table"
        >
          <template #progress>
            <div></div>
          </template>
          <template slot="body" slot-scope="props">
            <tbody>
              <tr
                v-for="item in props.items"
                :key="item.id"
                @click="
                  openDialogDetail(
                    item.signature,
                    item.directory_hash,
                    item.audiobook_id
                  )
                "
              >
                <td class="small">{{ formatCreatedAt(item.created_at) }}</td>
                <td class="bold">
                  <router-link
                    :to="{
                      name: 'AudiobooksDetail',
                      params: { id: item.audiobook_id },
                    }"
                  >
                    {{ item.audiobook_name }}<br />
                    <span class="small normal"
                      >ID: {{ item.audiobook_id }}</span
                    >
                  </router-link>
                </td>
                <td class="bold">
                  <router-link
                    :to="{
                      name: 'CustomersDetail',
                      params: { id: item.user_id },
                    }"
                  >
                    {{ item.user_name }}<br />
                    <span class="small normal">ID: {{ item.user_id }}</span>
                  </router-link>
                </td>
                <td class="small">
                  <span
                    v-if="item.signature"
                    @click="
                      openDialogDetail(
                        item.signature,
                        item.directory_hash,
                        item.audiobook_id
                      )
                    "
                  >
                    {{ item.signature.substring(0, 20) }}...
                  </span>
                </td>
                <!-- <td class="bold">{{ item.downloaded }}x</td>
                <td class="bold">{{ item.downloaded_app }}x</td> -->
                <td class="small bold">
                  <span v-if="item.status === 'ready'" class="status"
                    >{{ item.order }}. {{ item.status_name }}</span
                  >
                  <span
                    v-else-if="item.status === 'failed'"
                    class="status status--error"
                    >{{ item.status_name }}</span
                  >
                  <span
                    v-else-if="item.status === 'deleted'"
                    class="status status--error"
                    >{{ item.status_name }}</span
                  >
                  <span
                    v-else-if="item.status === 'done'"
                    class="status status--success"
                    >{{ item.status_name }}</span
                  >
                  <span
                    v-else-if="item.status === 'missing'"
                    class="status status--error"
                    >{{ item.status_name }}</span
                  >
                  <span
                    v-else-if="item.status === 'preparing'"
                    class="status"
                    >{{ item.status_name }}</span
                  >
                  <span v-else class="status status--normal"
                    ><span>{{ item.status_name }}</span></span
                  >
                </td>
                <td class="right small">
                  <!-- v-if="item.status === 'deleted' && !item.retried || item.status === 'failed' && !item.retried || item.status === 'missing' && !item.retried" -->
                  <!-- v-if="!['preparing', 'ready'].includes(item.status)" -->
                  <v-btn
                      color="primary"
                      type="submit"
                      class="button--small"
                      @click.stop="openDialogGenerate(item)"
                  >
                      Generovat znovu
                  </v-btn>
                </td>
              </tr>
              <div v-if="props.items.length == 0" class="text-no-results">
                <p>Žádná generovaná kniha nebyla nalezena</p>
              </div>
              <v-overlay
                  absolute
                  color="rgba(255, 255, 255, 0.8)"
                  :value="!loaded"
              >
                <div>
                  <div class="loader">
                    <div class="loader__item">
                    </div>
                  </div>
                </div>
              </v-overlay>
            </tbody>
          </template>

          <template slot="footer" slot-scope="totals">
            <div
              class="table-footer"
              v-bind:class="{
                'footer--no-results': totals.props.pagination.pageStop === 0,
              }"
            >
              <div class="table-footer__text">
                Počet generovaných knih na stránce
              </div>
              <div class="table-footer__pages">
                <span v-if="totals.props.pagination.pageStop > 0"
                  ><span class="table-footer__pages-bold"
                    >{{ totals.props.pagination.pageStart + 1 }}-{{
                      totals.props.pagination.pageStop
                    }}</span
                  >
                  z {{ totals.props.pagination.itemsLength }}</span
                >
                <span v-else
                  ><span class="table-footer__pages-bold"
                    >{{ totals.props.pagination.pageStart }}-{{
                      totals.props.pagination.pageStop
                    }}</span
                  >
                  z {{ totals.props.pagination.itemsLength }}</span
                >
              </div>
            </div>
          </template>
        </v-data-table>
      </v-layout>
      <v-dialog v-model="dialogDetail" persistent>
        <v-card>
          <v-card-title class="headline">Celý podpis</v-card-title>
          <v-card-text>
            <span v-if="currentSignature"> {{ currentSignature }}</span>
            <span v-else>Audiokniha ještě nebyla vygenerovaná!</span>
          </v-card-text>
          <v-card-title class="headline">Složka</v-card-title>
          <v-card-text>
            <span
              v-if="currentDirectory"
              @click="copyFolder()"
              style="cursor:pointer"
              ><b ref="folderPath"
                ><i
                  >/opt/app/data/prepared_mp3/{{ currentBookId }}/{{
                    currentDirectory
                  }}</i
                ></b
              ><br />(zkopírovat kliknutím a zavřít)</span
            >
            <span v-else>Složka ještě nebylo vytvořena!</span>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="empty"
              class="button--dialog"
              @click="closeDialogDetail()"
            >
              zavřít
            </v-btn>

            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogGenerate" persistent>
        <v-card>
          <v-card-title class="headline">Generovat znovu</v-card-title>
          <v-card-text>
            Opravdu chcete znovu vygenerovat knihu<br /><strong>{{
              currentBook
            }}</strong>
            uživateli <strong>{{ currentName }}</strong
            >? <br /><br />
            <span class="status status--error" v-if="bookAlreadyRemade"
              >Nová kopie audioknihy je už pro uživatele připravena nebo se
              právě připravuje.</span
            >
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="empty"
              class="button--dialog"
              @click="closeDialogGenerate()"
            >
              zavřít
            </v-btn>
            <!-- v-if="!bookAlreadyRemade" -->
            <v-btn
              color="primary"
              class="button--dialog"
              @click="generateNew()"
            >
              generovat
            </v-btn>

            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';
import { debounce } from 'lodash';

export default {
  name: 'Generating',
  components: {},
  data() {
    return {
      currentStatus: 'all',
      bookAlreadyRemade: true,
      dialogDetail: false,
      dialogGenerate: false,
      currentBook: '',
      currentName: '',
      currentId: '',
      currentSignature: '',
      currentDirectory: '',
      currentBookId: '',
      loaded: false,
      search: '',
      headers: [
        //  { text: '', value: '',  align: 'left',sortable: false },
        { text: 'Zahájení generování', value: 'created_at', align: 'left' },
        { text: 'Kniha', value: 'audiobook_name', align: 'left' },
        { text: 'Uživatel', value: 'user_name', align: 'left' },
        { text: 'Podpis', value: 'signature', align: 'left' },
        // { text: 'Staženo', value: 'downloaded', align: 'left' },
        // { text: 'Staženo v aplikaci', value: 'downloaded_app', align: 'left' },
        { text: 'Stav', value: 'status', align: 'left' },
        { text: '', value: '', align: 'left', sortable: false },
      ],
      items: [],
      options: {},
      total:0,
      perPage: 30,
    };
  },

  created() {
    this.fetchData();
  },
  computed: {
    ...mapState(['profile']),
  },
  mounted() {},
  methods: {
    copyFolder() {
      this.selectText(this.$refs.folderPath);
      document.execCommand('copy');
      this.$nextTick(() => {
        this.closeDialogDetail();
      });
    },
    selectText(element) {
      var range;
      if (document.selection) {
        // IE
        range = document.body.createTextRange();
        range.moveToElementText(element);
        range.select();
      } else if (window.getSelection) {
        range = document.createRange();
        range.selectNode(element);
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
      }
    },
    filterStatus(status) {
      this.currentStatus = status;
    },
    closeDialogDetail() {
      this.dialogDetail = false;
    },
    openDialogDetail(signature, directory, audiobook_id) {
      this.currentSignature = signature;
      this.currentDirectory = directory;
      this.currentBookId = audiobook_id;
      this.dialogDetail = true;
    },
    closeDialogGenerate() {
      this.dialogGenerate = false;
    },
    openDialogGenerate(item) {
      this.$axios
        .get('/admin/audiobooks/downloads/check/' + item.id)
        .then((response) => {
          this.currentBook = item.audiobook_name;
          this.currentName = item.user_name;
          this.currentId = item.id;
          this.dialogGenerate = true;
          this.bookAlreadyRemade = response.data.retried;

          if (response.data.retried) {
            this.fetchData(true);
          }
        })
        .catch((e) => {
          this.currentBook = item.audiobook_name;
          this.currentName = item.user_name;
          this.currentId = item.id;
          this.bookAlreadyRemade = true;
          this.dialogGenerate = true;
        });
    },
    generateNew() {
      this.$axios
        .post('/admin/audiobooks/downloads/new/' + this.currentId)
        .then((response) => {
          this.fetchData();
          this.dialogGenerate = false;
        })
        .catch((e) => {
          this.dialogGenerate = false;
        });
    },
    formatCreatedAt(date) {
      if (date) {
        return moment.unix(date).format('D.M.YYYY - HH:mm');
      } else {
        return null;
      }
    },
    async fetchData() {
      this.loaded = false;
      this.items = [];
      const params = {};
      if(this.options.page){
        params.page = this.options.page;
      }
      if(this.options.itemsPerPage)
      {
        params.perPage = this.options.itemsPerPage;
      }
      if(this.options.sortBy && this.options.sortBy.length > 0){
        params.sortBy = this.options.sortBy[0];
      }
      if(this.options.sortDesc && this.options.sortDesc.length > 0){
        params.order = this.options.sortDesc[0] ? 'DESC' : 'ASC';
      }
      if(this.search && this.search.length > 0){
        params.search = this.search;
      }
      if (this.currentStatus && this.currentStatus != 'all') {
        params.status = this.currentStatus;
      }
      this.$axios.get('/admin/audiobooks/downloads/list', { params }).then((response) => {
        response.data.downloads.forEach((item) => {
          if (item.status === 'missing') {
            item.status_name = 'Neexistuje';
          } else if (item.status === 'deleted') {
            item.status_name = 'Smazáno';
          } else if (item.status === 'failed') {
            item.status_name = 'Chybně vygenerováno';
          } else if (item.status === 'ready') {
            item.status_name = 'V pořadí';
          } else if (item.status === 'preparing') {
            item.status_name = 'Připravuje se';
          } else if (item.status === 'done') {
            item.status_name = 'Připraveno';
          } else if (item.status === 'app') {
            item.status_name = 'APP';
          } else {
            if (item.status) {
              item.status_name = 'Neznámý - ' + item.status;
            } else {
              item.status_name = 'Neznámý';
            }
          }
        });

        this.items = response.data.downloads;
        this.loaded = true;
        this.total = response.data.count;

      }).catch((e) => {
        this.loaded = true;
      });
    },
  },
  watch: {
    options() {
      this.fetchData();
    },
    search: debounce(function () {
      this.fetchData();
    }, 350),
    currentStatus() {
      this.fetchData();
    }
  },
};
</script>

<style lang="scss"></style>
